// this file is imported in index.js and exposed to the app through babel
const Logger = require('js-logger');

const PREFIX = 'JSL';
const APP_NAME = 'NIKECONNECT';
const LOG_NAME = `${PREFIX}:${APP_NAME}`;

// logging levels
const levels = {
  d: Logger.DEBUG,
  i: Logger.INFO,
  w: Logger.WARN,
  e: Logger.ERROR,
  x: Logger.OFF
};

// set default level to OFF for prod, otherwise WARN
const DEFAULT_LEVEL = process.env.NODE_ENV === 'production' ? 'w' : 'd';

// formatting is already handled in the global, so use defaults
Logger.useDefaults();

// retrieve level from localStorage, or default
function getPersistedLevel() {
  return window.localStorage.getItem(LOG_NAME) || DEFAULT_LEVEL;
}

// set level to localStorage
function setPersistedLevel(level) {
  // if level doesn't exist in object literal, use default
  const logLevel = levels[level] ? level : DEFAULT_LEVEL;
  // set the log level
  Logger.setLevel(levels[logLevel]);
  // save to localStorage
  window.localStorage.setItem(LOG_NAME, logLevel);
}

const persisted = getPersistedLevel();
setPersistedLevel(persisted);



// WEBPACK FOOTER //
// ./src/registerLogger.js